import { Box } from '@mui/material'
import * as React from 'react'

interface IVodArrow {
    icon: React.ReactElement
    onClick?: () => void
}

export const Arrow = ({ onClick, icon }: IVodArrow) => {
    if (!icon) return <></>

    const container = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
    }
    const arrowButton = {
        zIndex: 2,
        '&:hover': {
            cursor: 'pointer',
        },
        height: '100%',
        transition: 'all .4s ease-out;',
    }
    return (
        <Box sx={container} onClick={onClick}>
            <Box sx={arrowButton}>
                {React.cloneElement(icon, {
                    style: { width: '100%', height: '100%' },
                })}
            </Box>
        </Box>
    )
}
